module.exports = __webpack_public_path__ + "static/media/gradients_lightblue.de32721b.PNG";